module.exports = __webpack_public_path__ + "img/signal-01.c9a74fa4.svg";